// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

export function TipMessage(): Node {
  return (
    <Root>
      Ao clicar no botão abaixo você será redirecionado para a página do seu banco.
    </Root>
  );
}

const Root = styled.p`
  color: ${props => props.theme.colors.neutral[900]};
`;
